import {IMerchant} from "./merchant";

export class MerchantMapper {

  public static map(data: any): IMerchant {
    const merchant: IMerchant = <IMerchant>{};
    merchant.merchantId = data?.stripe_account_id;
    merchant.email = data?.data?.email;
    merchant.merchantStatus = data?.stripe_account_status;
    merchant.active = data?.is_active;
    merchant.websiteId = data?.domain_ids?.length ? data?.domain_ids[0] : null;
    merchant.websiteTitle = '';
    merchant.env = data?.env;

    return merchant;
  }

}
